<div
  class="c-casino-map__container"
  #casinoMapContainer
  theming
  themingGroup="progressline"
  [themingAsset]="'casino-map-bg'">
  <slotcom-navigation-button
    type="close"
    (click)="closeCasinoMap()" />

  <div
    class="c-casino-map__logo"
    data-testid="slotcom-casino-map-logo"
    theming
    themingGroup="progressline"
    [themingAsset]="'casino-map-logo'"></div>

  <div
    class="all-casinos-container"
    #scrollContainer
    dragScroll
    invertMouseScroll>
    <div class="roads-layer">
      @for (road of roads; track $index) {
        <div
          class="road-slot"
          [class.flipped]="$index % 2 === 0">
          <div
            class="road-image"
            theming
            themingGroup="progressline"
            [themingAsset]="'casino-map-road'"></div>
        </div>
      }
    </div>

    <div class="small-clouds-layer">
      @for (cloud of clouds; track $index) {
        <div class="clouds-small-container">
          <div
            #cloudBack
            class="clouds-small-back"
            theming
            themingGroup="progressline"
            [themingAsset]="'casino-map-clouds-small-back'"></div>
          <div
            #cloudFront
            class="clouds-small-front"
            theming
            themingGroup="progressline"
            [themingAsset]="'casino-map-clouds-small-front'"></div>
        </div>
      }
    </div>

    <div class="large-clouds-layer">
      <div
        class="cloud-image flipped"
        theming
        themingGroup="progressline"
        [themingAsset]="'casino-map-large-clouds'"></div>
      <div class="cloud-image-spacer"></div>
      <div
        class="cloud-image"
        theming
        themingGroup="progressline"
        [themingAsset]="'casino-map-large-clouds'">
        <div
          class="coming-soon"
          theming
          themingGroup="progressline"
          [themingAsset]="'casino-map-coming-soon'"></div>
      </div>
      <div
        class="start-sign"
        theming
        themingGroup="progressline"
        [themingAsset]="'casino-map-start-sign'"></div>
      <div
        class="start-post"
        theming
        themingGroup="progressline"
        [themingAsset]="'casino-map-start-post'"></div>
    </div>

    <div class="palms-layer">
      <div
        class="c-casino-map__fg-left"
        theming
        themingGroup="progressline"
        [themingAsset]="'casino-map-fg-left'"></div>

      <div
        class="c-casino-map__fg-right"
        theming
        themingGroup="progressline"
        [themingAsset]="'casino-map-fg-right'"></div>
    </div>

    <div class="casinos-layer">
      @for (casino of casinoList; track casino.order) {
        <div
          class="casino-logo"
          #casinoLogo
          [class.even]="casino.even"
          [class.odd]="!casino.even"
          [class.current]="casino.state === 'current'"
          [class.locked]="casino.state === 'locked'"
          [class.completed]="casino.state === 'completed'"
          theming
          themingGroup="progressline"
          [themingAsset]="'logo-' + casino.order"
          (click)="casino.state === 'current' && onCurrentCasinoClick(casinoLogo)">
          <div
            class="casino-pointer"
            data-testid="slotcom-casino-pointer"
            #casinoPointer
            theming
            themingGroup="progressline"
            [themingAsset]="'casino-pointer'"></div>
          @if (casino.state === 'current') {
            @for (spark of [1, 2, 3]; track spark) {
              <div
                [class]="'casino-spark-' + spark"
                #casinoSpark
                theming
                themingGroup="progressline"
                [themingAsset]="'casino-spark'"></div>
            }
          }
          <div
            class="casino-frame"
            theming
            themingGroup="progressline"
            [themingAsset]="'casino-frame-' + casino.tier">
            <span [style.font-size]="'1.15em'">{{ casino.order }}</span>
          </div>
          <div
            class="casino-name"
            [class.locked]="casino.state === 'locked'"
            theming
            themingGroup="progressline"
            [themingAsset]="'casino-title-' + casino.order"></div>
          @if (casino.state === 'locked') {
            <div
              class="locked-icon"
              (click)="showLockedInfo(lockGlyph, lockInfo)">
              <div
                class="lock-glyph"
                #lockGlyph
                theming
                themingGroup="none"
                [themingAsset]="'lock'"></div>
              <span
                class="locked-info"
                #lockInfo
                >{{ 'home.progress-line.casino-map.locked-casino' | translate }}</span
              >
            </div>
          }
          <div
            class="completed-icon"
            theming
            themingGroup="none"
            [themingAsset]="'check'"></div>
        </div>
      }
    </div>
  </div>
  <div class="casino-map-subtitle">
    <span>{{ 'home.progress-line.casino-map.subtitle-1' | translate }}</span>
    <div
      class="prestige-icon"
      theming
      themingGroup="progressline"
      [themingAsset]="'prestige-logo'"></div>
    <span>{{ 'home.progress-line.casino-map.subtitle-2' | translate }}</span>
  </div>
</div>
